<app-dialog
  headerText="Helm Chart Download"
  [body]="body"
  [showCancelButton]="true"
  cancelText="Close"
  [showSaveButton]="false"
  [showTopCancelButton]="false"
  (cancel)="onClose()"
></app-dialog>

<ng-template #body>
  <div>
    Downloading your app's Helm chart now. Please check your browser downloads.
    <br /><br />
    When you're ready, you can apply the resources in the Helm chart using the
    Unified Resource Manager (URM) Helm plugin. Go to the
    <a
      href="https://pages.github.tools.sap/atom-cfs/atom-docs/docs/atom-tools/helm_plugin/"
      target="_blank"
      fd-link
      >documentation</a
    >.

    @if (numberOfParameterIssues) {
      <br /><br />
      NOTE: We detected some issues ({{ numberOfParameterIssues }}) when adding
      parameters of service instances and/or subscriptions to the
      AutomationSolution configuration for the consumer test subaccount. To view
      these details, make sure you select the option to download the PDF report
      before you close this dialog.
    }
  </div>

  <div class="checkbox-wrapper">
    @if (numberOfParameterIssues) {
      <fd-checkbox
        label="Download PDF report of AutomationSolution parameter issues"
        [(ngModel)]="downloadReport"
        (change)="onDownloadReportChange()"
        [fdCompact]="true"
        inputId="downloadReportCheckbox"
      ></fd-checkbox>
    }
  </div>
</ng-template>
